import React from 'react';
import { FormHelperText } from '@mui/material';

export function FormErrorDisplay({ error, touched }: { error: string | undefined; touched: boolean | undefined }) {
  return error && touched ? (
    <FormHelperText error sx={{ mt: 0.5 }}>
      {error}
    </FormHelperText>
  ) : null;
}

export function FormArrayErrorDisplay({ error, submitCount }: { error: string | undefined; submitCount: number }) {
  return error && submitCount > 0 ? (
    <FormHelperText error sx={{ mt: 0.5 }}>
      {error}
    </FormHelperText>
  ) : null;
}

export function FormObjectErrorDisplay({ error, submitCount }: { error: string | undefined; submitCount: number }) {
  return error && submitCount > 0 ? (
    <FormHelperText error sx={{ mt: 0.5 }}>
      {error}
    </FormHelperText>
  ) : null;
}

export default FormErrorDisplay;
